import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  setUser,
  setUserById,
  setDeleteUser,
  adminUserTypes as types,
} from "../actions";
import { AxiosResponse } from "axios";
import {
  getUserService,
  getUserByIdService,
  deleteUserByIdService,
  editUserService,
  getUserByRoleService,
  signUpService,
  logoutUserService,
} from "../../../services/educator/user";
import { EntityIdPayload } from "../../../utils";
import showNotification from "../../../services/notificationService";
import StorageService from "../../../services/storageService";

export default function* adminUserSagas() {
  yield all([
    takeLatest(types.ADMIN_GET_USER, handleGetUser),
    takeLatest(types.ADMIN_GET_USER_BY_ID, handleGetUserById),
    takeLatest(types.ADMIN_DELETE_USER, handleDeleteUser),
    takeLatest(types.ADMIN_EDIT_USER, handleEditUser),
    takeLatest(types.ADMIN_GET_USER_BY_ROLE, handleGetUserByRole),
    takeLatest(types.ADMIN_SIGN_UP, handleSignUp),
    takeLatest(types.LOGOUT_ADMIN, handleLogout),
  ]);
}

function* handleGetUser() {
  const { data }: AxiosResponse = yield call(getUserService);
  if (data) {
    yield put(setUser({ users: data }));
  }
}

function* handleGetUserById(action: EntityIdPayload) {
  const { data }: AxiosResponse = yield call(
    getUserByIdService,
    action.payload.id
  );
  if (data) {
    yield put(setUserById({ user: data }));
  }
}

function* handleDeleteUser(action: EntityIdPayload) {
  const { data }: AxiosResponse = yield call(
    deleteUserByIdService,
    action.payload.id
  );
  if (data) {
    yield put(setDeleteUser(action.payload.id));
    showNotification("success", "User deleted successfully");
  }
}

function* handleEditUser(action: any) {
  const { data }: AxiosResponse = yield call(
    editUserService,
    action.payload.id,
    action.payload.user
  );
  if (data) {
    showNotification("success", "User updated successfully");
  }
}

function* handleGetUserByRole(action: any) {
  const { data }: AxiosResponse = yield call(
    getUserByRoleService,
    action.payload
  );
  if (data) {
    yield put(setUser({ users: data }));
  }
}

function* handleSignUp(action: any) {
  const { data }: AxiosResponse = yield call(signUpService, action.payload);
  if (data) {
    showNotification("success", "Invitation sent successfully");
  }
}

function* handleLogout(action: any) {
  const { data }: AxiosResponse = yield call(logoutUserService);
  StorageService.clearStorage();
  yield put({
    type: "LOGOUT",
    payload: null,
  });
  action.payload.navigate("/login");
}
